export default {
      id: "oc-res-children-task-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-children-task",
      toString: function () {
        return this.url;
      }
    }